"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyDashboardError = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var EmptyDashboardErrorCore = function (_a) {
    var ErrorComponent = _a.ErrorComponent, intl = _a.intl;
    return (react_1.default.createElement(ErrorComponent, { message: intl.formatMessage({ id: "dashboard.error.empty.heading" }), description: intl.formatMessage({ id: "dashboardView.error.empty.text" }) }));
};
exports.EmptyDashboardError = react_intl_1.injectIntl(EmptyDashboardErrorCore);
//# sourceMappingURL=EmptyDashboardError.js.map